(function () {
  function update(variantId, container) {
    if (!variantId || !container) return;

    var productId = container.dataset.productId;
    var threshold = parseInt(container.dataset.threshold, 10);
    if (isNaN(threshold)) threshold = 3;

    var inventoryByProduct = window.inventories || {};
    var data = inventoryByProduct[productId] && inventoryByProduct[productId][variantId];
    var label = container.querySelector('.js-variant-inventory');
    if (!label) return;

    var visible = false;
    var quantity = 0;
    var isComingSoon = container.dataset.comingSoon === 'true';
    if (!isComingSoon && data && data.policy !== 'continue' && typeof data.quantity === 'number' && data.quantity > 0 && data.quantity <= threshold) {
      visible = true;
      quantity = data.quantity;
    }

    if (visible) {
      var template = container.dataset.stockLabel || '';
      label.textContent = template.replace('[count]', String(quantity));
      container.removeAttribute('hidden');
    } else {
      label.textContent = '';
      container.setAttribute('hidden', '');
    }
  }

  function init() {
    var containers = document.querySelectorAll('[data-product-inventory-wrapper]');
    if (!containers.length) return;
    if (typeof Events === 'undefined' || !Events.on) return;

    Events.on('variantinputchange', function (variant) {
      if (!variant || !variant.id) return;

      var matched;
      if (variant.product_id) {
        matched = document.querySelectorAll('[data-product-inventory-wrapper][data-product-id="' + variant.product_id + '"]');
      } else {
        matched = containers;
      }
      Array.prototype.forEach.call(matched, function (c) { update(variant.id, c); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
